import React from 'react';
import { buildGroupInitialUrl } from '~/ProductGroup';
import { useStore } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import LinkFlashMessage from './LinkFlashMessage';

const GroupLinkFlashMessage: React.FC<
	React.PropsWithChildren<{ group: UserProductGroup; linkTitle: string; text: string }>
> = (props) => {
	// TODO: Add correct type
	const store = useStore<any>();
	const link = buildGroupInitialUrl(props.group, store.getState());

	return <LinkFlashMessage link={link} linkTitle={props.linkTitle} text={props.text} />;
};

GroupLinkFlashMessage.displayName = 'FlashMessage.GroupLinkFlashMessage';

export default GroupLinkFlashMessage;
